import { type ArenaOffersName } from '@/common/types/shop/marketBoxes';

import battleStartPng from '/img/shop/arenaOffers/battleStart.png';
import battleStartWebp from '/img/shop/arenaOffers/battleStart.webp';
import finalStageLargePng from '/img/shop/arenaOffers/finalStageLarge.png';
import finalStageLargeWebp from '/img/shop/arenaOffers/finalStageLarge.webp';
import finalStageSmallPng from '/img/shop/arenaOffers/finalStageSmall.png';
import finalStageSmallWebp from '/img/shop/arenaOffers/finalStageSmall.webp';
import growthKitBigPng from '/img/shop/arenaOffers/growthKitBig.png';
import growthKitBigWebp from '/img/shop/arenaOffers/growthKitBig.webp';
import growthKitGiantPng from '/img/shop/arenaOffers/growthKitGiant.png';
import growthKitGiantWebp from '/img/shop/arenaOffers/growthKitGiant.webp';
import growthKitSmallPng from '/img/shop/arenaOffers/growthKitSmall.png';
import growthKitSmallWebp from '/img/shop/arenaOffers/growthKitSmall.webp';
import battleStartPopupPng from '/img/shop/arenaOffers/popup/battleStart.png';
import battleStartPopupWebp from '/img/shop/arenaOffers/popup/battleStart.webp';
import finalStageLargePopupPng from '/img/shop/arenaOffers/popup/finalStageLarge.png';
import finalStageLargePopupWebp from '/img/shop/arenaOffers/popup/finalStageLarge.webp';
import finalStageSmallPopupPng from '/img/shop/arenaOffers/popup/finalStageSmall.png';
import finalStageSmallPopupWebp from '/img/shop/arenaOffers/popup/finalStageSmall.webp';
import growthKitBigPopupPng from '/img/shop/arenaOffers/popup/growthKitBig.png';
import growthKitBigPopupWebp from '/img/shop/arenaOffers/popup/growthKitBig.webp';
import growthKitGiantPopupPng from '/img/shop/arenaOffers/popup/growthKitGiant.png';
import growthKitGiantPopupWebp from '/img/shop/arenaOffers/popup/growthKitGiant.webp';
import growthKitSmallPopupPng from '/img/shop/arenaOffers/popup/growthKitSmall.png';
import growthKitSmallPopupWebp from '/img/shop/arenaOffers/popup/growthKitSmall.webp';
import powerBoostLargePopupPng from '/img/shop/arenaOffers/popup/powerBoostLarge.png';
import powerBoostLargePopupWebp from '/img/shop/arenaOffers/popup/powerBoostLarge.webp';
import powerBoostSmallPopupPng from '/img/shop/arenaOffers/popup/powerBoostSmall.png';
import powerBoostSmallPopupWebp from '/img/shop/arenaOffers/popup/powerBoostSmall.webp';
import profitDropPopupPng from '/img/shop/arenaOffers/popup/profitDrop.png';
import profitDropPopupWebp from '/img/shop/arenaOffers/popup/profitDrop.webp';
import superStartPopupPng from '/img/shop/arenaOffers/popup/superStart.png';
import superStartPopupWebp from '/img/shop/arenaOffers/popup/superStart.webp';
import powerBoostLargePng from '/img/shop/arenaOffers/powerBoostLarge.png';
import powerBoostLargeWebp from '/img/shop/arenaOffers/powerBoostLarge.webp';
import powerBoostSmallPng from '/img/shop/arenaOffers/powerBoostSmall.png';
import powerBoostSmallWebp from '/img/shop/arenaOffers/powerBoostSmall.webp';
import profitDropLargePng from '/img/shop/arenaOffers/profitDropLarge.png';
import profitDropLargeWebp from '/img/shop/arenaOffers/profitDropLarge.webp';
import profitDropSmallPng from '/img/shop/arenaOffers/profitDropSmall.png';
import profitDropSmallWebp from '/img/shop/arenaOffers/profitDropSmall.webp';
import superStartPng from '/img/shop/arenaOffers/superStart.png';
import superStartWebp from '/img/shop/arenaOffers/superStart.webp';

interface ImageAssets {
  png: string;
  webp: string;
}

interface Ticker {
  default: string;
  discount: string;
}

export interface ArenaOfferInfo {
  title: string;
  describe: string;
  ticker: Ticker;
  img: ImageAssets;
  imgPopup: ImageAssets;
  color: 'green' | 'yellow' | 'red' | 'purple' | undefined;
}

type ArenaOffersInfo = {
  [key in ArenaOffersName]: ArenaOfferInfo;
};

const arenaOffersInfo: ArenaOffersInfo = {
  superStart: {
    title: 'Super start!',
    describe: 'Boost your arena journey',
    ticker: {
      default: 'EXCLUSIVE',
      discount: 'EXCLUSIVE',
    },
    img: {
      png: superStartPng,
      webp: superStartWebp,
    },
    imgPopup: {
      png: superStartPopupPng,
      webp: superStartPopupWebp,
    },
    color: 'purple',
  },
  battleStart: {
    title: 'Let the battle begin!',
    describe: 'The perfect pack to start on the arena',
    ticker: {
      default: 'START',
      discount: 'LIMITED',
    },
    img: {
      png: battleStartPng,
      webp: battleStartWebp,
    },
    imgPopup: {
      png: battleStartPopupPng,
      webp: battleStartPopupWebp,
    },
    color: 'green',
  },
  powerBoostSmall: {
    title: 'Peak of the competition',
    describe: 'Support to reach new heights',
    ticker: {
      default: 'PUSH',
      discount: 'LIMITED',
    },
    img: {
      png: powerBoostSmallPng,
      webp: powerBoostSmallWebp,
    },
    imgPopup: {
      png: powerBoostSmallPopupPng,
      webp: powerBoostSmallPopupWebp,
    },
    color: 'yellow',
  },
  powerBoostLarge: {
    title: 'Power booster',
    describe: 'Growth pack for the heat of competition',
    ticker: {
      default: 'POWER',
      discount: '🔥HOT',
    },
    img: {
      png: powerBoostLargePng,
      webp: powerBoostLargeWebp,
    },
    imgPopup: {
      png: powerBoostLargePopupPng,
      webp: powerBoostLargePopupWebp,
    },
    color: 'yellow',
  },
  finalStageSmall: {
    title: 'Final stretch!',
    describe: "Use the moment while there's still time",
    ticker: {
      default: 'RUSH',
      discount: 'LIMITED',
    },
    img: {
      png: finalStageSmallPng,
      webp: finalStageSmallWebp,
    },
    imgPopup: {
      png: finalStageSmallPopupPng,
      webp: finalStageSmallPopupWebp,
    },
    color: 'red',
  },
  finalStageLarge: {
    title: 'All or nothing!',
    describe: 'Maximum power for a victorious finish',
    ticker: {
      default: 'FINAL',
      discount: 'FINAL',
    },
    img: {
      png: finalStageLargePng,
      webp: finalStageLargeWebp,
    },
    imgPopup: {
      png: finalStageLargePopupPng,
      webp: finalStageLargePopupWebp,
    },
    color: 'red',
  },
  growthKitSmall: {
    title: 'Strategic reserve',
    describe: 'Improve your power before competitions',
    ticker: {
      default: 'LIMITED',
      discount: 'LIMITED',
    },
    img: {
      png: growthKitSmallPng,
      webp: growthKitSmallWebp,
    },
    imgPopup: {
      png: growthKitSmallPopupPng,
      webp: growthKitSmallPopupWebp,
    },
    color: 'purple',
  },
  growthKitBig: {
    title: 'Full setup',
    describe: 'Everything you need to dominate',
    ticker: {
      default: 'LIMITED',
      discount: 'LIMITED',
    },
    img: {
      png: growthKitBigPng,
      webp: growthKitBigWebp,
    },
    imgPopup: {
      png: growthKitBigPopupPng,
      webp: growthKitBigPopupWebp,
    },
    color: 'purple',
  },
  growthKitGiant: {
    title: 'Ultimate control',
    describe: 'Nothing stands in your way',
    ticker: {
      default: 'LIMITED',
      discount: 'LIMITED',
    },
    img: {
      png: growthKitGiantPng,
      webp: growthKitGiantWebp,
    },
    imgPopup: {
      png: growthKitGiantPopupPng,
      webp: growthKitGiantPopupWebp,
    },
    color: 'purple',
  },
  profitDropSmall: {
    title: 'Profit Drop 1 of 4',
    describe: 'Boost your arena journey',
    ticker: {
      default: 'LIMITED OFFER',
      discount: 'LIMITED OFFER',
    },
    img: {
      png: profitDropSmallPng,
      webp: profitDropSmallWebp,
    },
    imgPopup: {
      png: profitDropPopupPng,
      webp: profitDropPopupWebp,
    },
    color: 'purple',
  },
  profitDropLarge: {
    title: 'Proffit Drop 1 of 4',
    describe: 'Boost your arena journey',
    ticker: {
      default: 'LIMITED OFFER',
      discount: 'LIMITED OFFER',
    },
    img: {
      png: profitDropLargePng,
      webp: profitDropLargeWebp,
    },
    imgPopup: {
      png: profitDropPopupPng,
      webp: profitDropPopupWebp,
    },
    color: 'purple',
  },
};

type ProfitDropRewardType = 'arenaOffer' | 'lottery' | 'tgem' | 'usdt';

// Shop v2 card palette: background glow and subtitle colour
const arenaOfferColors: Record<
  NonNullable<ArenaOfferInfo['color']>,
  { glow: string; text: string }
> = {
  purple: { glow: '#9955FF', text: '#E7D7FF' },
  green: { glow: '#82E024', text: '#B8FFB6' },
  yellow: { glow: '#FFD600', text: '#FFFDB6' },
  red: { glow: '#FF5858', text: '#FFB6B6' },
};

export { arenaOfferColors, arenaOffersInfo };
export type { ProfitDropRewardType };
